import { useEffect, useRef } from 'react';

const useClickOutside = (callback = () => {}) => {
  const ref = useRef(null);
  const refId = useRef(String(Math.random()));

  const handleDocumentClick = event => {
    const isInside = event
      .composedPath()
      .map(el => el.id)
      .includes(refId.current);

    if (!isInside) callback();
  }

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    if (ref.current) ref.current.id = refId.current;

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ({
    ref,
  })
};

export default useClickOutside;
